import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import { stateKorea } from '../../utils/Languages';
import { useParams } from 'react-router';
import buskwarehousedetail from '@modules/Busk/BuskWarehouseDetail/services/buskwarehousedetail';
import { formatDateTime } from '@root/utils/helpers/formatDate';

interface Props {
  formData: any;
}

const SignUpDate = ({ formData }: Props) => {
  const { id } = useParams<{ id: string }>();
  const handleExport = async () => {
    const response = await buskwarehousedetail.exportAll(id);
    const outputFilename = `Warehouse_all_240406T9g6QGJSxyR.zip`;

    const url = URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div
      style={{
        padding: '1rem',
        backgroundColor: 'white',
        marginBottom: '2rem'
      }}
    >
      <Row>
        <Col flex={10}>
          가입일 {formatDateTime(formData?.createdAt)}
          <Typography.Text
            style={{
              background: '#2B2C51',
              padding: '.5rem 2rem',
              borderRadius: '1rem',
              color: 'white',
              marginLeft: '10px'
            }}
          >
            {formData?.accountState}
          </Typography.Text>
        </Col>
        <Col flex={0.1}>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SignUpDate;
